import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { v4 as uuidv4 } from 'uuid';

import { FormsModule } from '@angular/forms';
import { DropDownListModule } from '@progress/kendo-angular-dropdowns';
import {  ExcelModule, GridModule } from '@progress/kendo-angular-grid';
import { TextBoxModule } from '@progress/kendo-angular-inputs';
import { ICompany, IUser } from '../../../models';
import { AdminService } from '../../../services';
import { BaseGridComponent } from '../../base-grid/base-grid.component';
import { UserFilter } from '../../users/user.filter';
import { UserForm } from '../../users/users-editor/user.form';
import { UsersEditorComponent } from '../../users/users-editor/users-editor.component';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
  standalone: true,
  imports: [GridModule, TextBoxModule,  ExcelModule,  DropDownListModule, FormsModule]
})
export class UsersComponent extends BaseGridComponent<IUser>{

  private companies: ICompany[] | null = null;
  private gotData: boolean = false;

  constructor(adminService: AdminService, modalService: NgbModal) {
    super(adminService, modalService);
    this.filter = new UserFilter();
  }

  retrieveItems(): void {
    this.retrieveUsers();
    this.retrieveCompanies();
  }

  retrieveUsers(): void {
    this.adminService.getAllUsers()
      .subscribe(
        data => {
          this.items = data;
          this.filteredItems = this.items;

          this.haveAllData();
        });
  }

  retrieveCompanies(): void {
    this.adminService.getAllCompanies()
      .subscribe(
        data => {
          this.companies = data;

          this.haveAllData();
        });
  }

  refreshItems(): void {
    this.retrieveUsers();
  }

  haveAllData(): void {
    if (this.gotData == false
      && this.companies != null
      && this.items != null) {
      this.gotData = true;
      this.loadItems();
    }
  }

  saveItem(item: IUser, isNew: boolean): void {

    this.adminService.saveUser(item, isNew)
      .subscribe(
        _response => {
          this.refreshItems();
        },
        error => {
          // Raise Error
          console.error(error);
        });
  }


  public addHandler({ sender }: any) {

    var user: IUser = {
      id: uuidv4(),
      firstName: "",
      lastName: "",
      imageUrl: "",
      alias: "",
      email: "",
      companyId: "",
      isActive: true
    };

    const size = 'lg';
    const options = {
      title: "Add User", windowClass: "modal-preferences",
      showSave: true, showCancel: true, showCross: true, scrollable: false, saveText: 'Add'
    };

    this.showEditorModal(size, options, UsersEditorComponent, new UserForm(user, this.companies), true);
  }

  public editHandler({ sender, rowIndex, dataItem }: any) {
    const size = 'lg';
    const options = {
      title: "Edit User", windowClass: "modal-preferences",
      showSave: true, showCancel: true, showCross: true, scrollable: false
    };

    this.showEditorModal(size, options, UsersEditorComponent, new UserForm(dataItem, this.companies), false);
  }

  public removeHandler({ dataItem }: any): void {
    this.adminService.removeUser(dataItem)
      .subscribe(
        _response => {
          this.refreshItems();
        },
        error => {
          // Raise Error
          console.error(error);
        });
  }

  public companyName(id: string): string {
    if (this.companies) {
      return this.companies.find(co => co.id == id)!.name ?? '';
    }
    else {
      return 'n/a';
    }
  }

}
